import { queryClient } from 'api/services/queryClient';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { UpdatePersonArg, UpdatePersonResult } from 'lib/services/personsApi';
import { type MutationOptions, useMutation, type UseMutationResult } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useUpdatePerson = ({
  onSuccess,
}: Pick<MutationOptions<UpdatePersonResult, unknown, UpdatePersonArg>, 'onSuccess'> = {}): UseMutationResult<
  UpdatePersonResult,
  unknown,
  UpdatePersonArg
> => {
  const { personsApiClient } = useServices();
  const appNotification = useAppNotifications();

  return useMutation(async (arg: UpdatePersonArg) => await personsApiClient.update(arg), {
    mutationKey: MUTATION_KEYS.persons.updateOne(),
    onError: error => {
      appNotification.error({
        message: 'There was an error while updating person',
        description: getErrorMessage(error),
      });
    },
    onSuccess: (data, variables, context) => {
      appNotification.success({
        message: `Person updated`,
      });
      queryClient.invalidateQueries(QUERY_KEYS.persons.all());
      onSuccess?.(data, variables, context);
    },
  });
};
